var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImageNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2844 2.02394H4.27217C3.02953 2.02394 2.02217 3.03129 2.02217 4.27394V31.2862L4.52217 28.7862V26.7619L13.5024 17.0633L14.8901 18.4183L16.658 16.6504L13.4123 13.481L4.52217 23.0823V4.52394H28.7844L31.2844 2.02394ZM0 37.551L1.72115 39.2722L3.57838 37.4149C3.79691 37.4857 4.03008 37.5239 4.27217 37.5239H35.2722C36.5148 37.5239 37.5222 36.5166 37.5222 35.2739V4.27394C37.5222 4.03184 37.4839 3.79868 37.4132 3.58015L39.2722 1.72115L37.551 0L0 37.551ZM35.0222 5.97115L20.5462 20.4472L24.7713 24.573L29.9712 20.0522L35.0222 25.2094V5.97115ZM18.7783 22.2151L5.96939 35.0239H35.0222V28.7823L29.8336 23.4846L24.673 27.9712L18.7783 22.2151Z",
    fill: "#56595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageNotAvailable);
export default __webpack_public_path__ + "static/media/icon-image-not-available.acdaa7095400162f5bc79a86baa56ed7.svg";
export { ForwardRef as ReactComponent };